import React, { useState } from 'react';

const TABS = [
  { id: 'brief', label: 'Briefing' },
  { id: 'explain', label: 'Explain' },
  { id: 'compare', label: 'Compare' },
  { id: 'watch', label: 'Watch' },
];

export default function ActiveIssueBoard({ insight }) {
  const [tab, setTab] = useState('brief');
  if (!insight) {
    return <div className="atl-empty" data-testid="issue-board-empty">Select an issue to view the briefing</div>;
  }

  const sources = insight.sources || insight.evidence || [];
  const assessment = insight.assessment || insight.summary || insight.briefing || '';
  const explain = insight.explainer || insight.rationale || insight.reasoning || '';
  const compare = insight.comparison || insight.prior_calls || insight.related || [];
  const watch = insight.watchpoints || insight.watch_list || insight.followups || [];

  return (
    <div className="issue-board" data-testid="issue-board">
      <h3 data-testid="issue-title">{insight.title || insight.headline || 'Active Issue'}</h3>
      <div className="meta">
        <span>{(insight.domain || insight.sector || '—').replace(/_/g, ' ')}</span>
        <span>·</span>
        <span>{insight.region || insight.scope || '—'}</span>
        <span>·</span>
        <span>sev {Math.round((insight.severity || 0) * 100)}</span>
        <span>·</span>
        <span>conf {Math.round((insight.confidence || 0) * 100)}%</span>
      </div>

      <div className="issue-tabs" data-testid="issue-tabs">
        {TABS.map((t) => (
          <button
            key={t.id}
            className={tab === t.id ? 'is-active' : ''}
            onClick={() => setTab(t.id)}
            data-testid={`issue-tab-${t.id}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="issue-body">
        {tab === 'brief' && <p data-testid="issue-tab-body-brief">{assessment || 'No briefing available yet.'}</p>}
        {tab === 'explain' && <p data-testid="issue-tab-body-explain">{explain || 'No explainer generated yet.'}</p>}
        {tab === 'compare' && (
          <div data-testid="issue-tab-body-compare">
            {Array.isArray(compare) && compare.length ? (
              compare.slice(0, 6).map((c, idx) => (
                <div key={idx} style={{ padding: '6px 0', borderBottom: '1px dashed var(--studio-border)', fontSize: 12 }}>
                  {typeof c === 'string' ? c : (c.title || c.summary || JSON.stringify(c).slice(0, 140))}
                </div>
              ))
            ) : <p>No prior/related calls to compare.</p>}
          </div>
        )}
        {tab === 'watch' && (
          <ul style={{ margin: 0, paddingLeft: 16 }} data-testid="issue-tab-body-watch">
            {Array.isArray(watch) && watch.length ? watch.map((w, idx) => (
              <li key={idx} style={{ marginBottom: 6 }}>{typeof w === 'string' ? w : (w.item || w.summary)}</li>
            )) : <li style={{ color: 'var(--studio-text-2)' }}>No watchpoints queued.</li>}
          </ul>
        )}
      </div>

      {sources.length > 0 && (
        <div className="issue-evidence" data-testid="issue-evidence">
          <div className="studio-label" style={{ marginBottom: 8 }}>Evidence ({sources.length})</div>
          {sources.slice(0, 8).map((s, idx) => (
            <div className="src" key={idx}>
              <span className="name">{s.name || s.source || s.provider || s.url || `source ${idx + 1}`}</span>
              <span className="conf">{s.confidence != null ? `${Math.round(s.confidence * 100)}%` : '—'}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
